"use client";

import React from "react";
import { cn } from "@/lib/utils";

export interface PageProps {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

/**
 * Page wrapper inside the route shell's main landmark.
 * Use as the top-level wrapper for page content.
 * Fills the space below the navbar without adding another viewport of height.
 * Uses shadcn design tokens (bg-background, text-foreground).
 *
 * Uses `cn` (tailwind-merge) so callers can override base classes
 * (e.g. a chat shell that uses a fixed height).
 */
const Page = React.forwardRef<HTMLDivElement, PageProps>(
  ({ className = "", children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex min-w-0 flex-1 flex-col font-sans bg-transparent text-foreground",
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Page.displayName = "Page";

export default Page;
